

export function validate_alphanumeric(theData){

    const regex = /^([a-zA-Z0-9])+$/;

    if( regex.test(theData) ) return true;

    return "txt61";
};